export default [
    {
        index: 0,
        custom: false,
        key: "id",
        type: "field",
    },
    {
        index: 1,
        custom: false,
        key: "civility",
        type: "field",
    },
    {
        index: 2,
        custom: false,
        key: "fullname",
        type: "field",
    },
    {
        index: 3,
        custom: true,
        expression: {
            value: "{company}",
            type: "string",
        },
        key: "",
        type: "field",
        empty: {
            html: 'Aucune Company'
        }
    },
    {
        index: 4,
        custom: false,
        key: "country",
        type: "field",
    },
    {
        index: 5,
        custom: true,
        expression: {
            value: "{address1}",
            type: "string",
        },
        key: "",
        type: "field",
        empty: {
            html: 'Aucune address'
        }
    },
    {
        index: 6,
        custom: true,
        expression: {
            value: "{postal_code}",
            type: "string",
        },
        key: "",
        type: "field",
        empty: {
            html: 'Aucun CP'
        }
    },
    {
        index: 7,
        custom: true,
        expression: {
            value: "{city}",
            type: "string",
        },
        key: "",
        type: "field",
        empty: {
            html: 'Ville non renseignée'
        }
    },
    {
        index: 8,
        custom: true,
        expression: {
            value: "{telephone1}",
            type: "string",
        },
        key: "",
        type: "field",
        empty: {
            html: 'Aucun telephone'
        }
    },
    {
        index: 9,
        custom: true,
        expression: {
            value: "{type_contact}",
            type: "string",
        },
        key: "",
        type: "field",
    },
    {
        index: 10,
        custom: true,
        option: [
            {
                text: "Editer",
                icon: "fa fa-eye",
                action: "click",
                parameter: "ref",
                key: "id",
                type: "field",
                onclick : ()=>alert('salut la team'),

            },
        ],
        key: "",
        type: "option",
    },
]
